@import 'core';

/**
 * @prop --ads-tooltip-content-background-color: The content background color for ads-tooltip
 * @prop --ads-tooltip-content-border-color: The content border color for ads-tooltip
 * @prop --ads-tooltip-content-color: The content font color for ads-tooltip
 *
 * @prop --ads-tooltip-trigger-background-color: The trigger background color for ads-tooltip
 * @prop --ads-tooltip-trigger-color: The trigger color for ads-tooltip
 * @prop --ads-tooltip-trigger-color-active: The trigger color for ads-tooltip on active
 * @prop --ads-tooltip-trigger-color-hover: The trigger color for ads-tooltip on hover
 */

// Trigger
$trigger-size: 12px;
$trigger-padding: 2px;
$trigger-render-size: $trigger-size + ($trigger-padding * 2);

// Content
$content-border-width: 1px;
$content-pointer-size: 3px;
$content-pointer-distance-in: 10px;

/**
 * Mixin to place the content box pointer
 */
@mixin pointer-placement(
  $border-width: 0 0 $content-border-width $content-border-width,
  $bottom: auto,
  $left: -$content-pointer-size,
  $right: auto,
  $top: $content-pointer-distance-in,
  $transform: rotate(45deg)
) {
  border-width: $border-width;
  bottom: $bottom;
  left: $left;
  right: $right;
  top: $top;
  transform: $transform;
}

::slotted([slot='content']) {
  display: block !important;
  width: 100%;
}

:host {
  box-sizing: border-box;
  display: inline-block;

  * {
    box-sizing: inherit;
  }
}

:host([theme='default']) {
  @include ads-vars-component-tooltip-default;
}

:host([theme='dark']) {
  @include ads-vars-component-tooltip-dark;
}

:host([dir='ltr']) {
  @include ads-vars-component-tooltip-ltr;
}

:host([dir='rtl']) {
  @include ads-vars-component-tooltip-rtl;
}

.c-tooltip {
  display: inline-flex !important;
  height: inherit;
  width: inherit;

  &__trigger {
    @include ads-tooltip-trigger;
    align-items: center;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    border: 0;
    cursor: pointer;
    display: inline-flex;
    font-size: 14px;
    height: inherit;
    justify-content: center;
    padding: 0;
    width: inherit;
    z-index: $layer-1;
  }

  &__content {
    @include ads-tooltip-content;
    border-radius: 5px;
    border-style: solid;
    border-width: 1px;
    display: flex;
    font-family: var(--ads-font-family);
    font-size: 12px;
    font-weight: 400;
    max-width: 200px;
    overflow-wrap: break-word;
    padding: 10px;
    position: absolute;
    text-align: var(--ads-tooltip-content-text-align, $ads-tooltip-content-text-align-ltr);
    z-index: $layer-3;

    &::before {
      border-style: solid;
      border-width: $content-border-width;
      content: '';
      height: $content-pointer-size;
      position: absolute;
      width: $content-pointer-size;
    }

    &.has-no-max-width {
      max-width: initial;
    }

    &.is-top::before {
      @include pointer-placement(0 $content-border-width $content-border-width 0, -$content-pointer-size, $content-pointer-distance-in, auto, auto);
    }

    &.is-right::before {
      @include pointer-placement;
    }

    &.is-bottom::before {
      @include pointer-placement($content-border-width 0 0 $content-border-width, auto, $content-pointer-distance-in, auto, -$content-pointer-size);
    }

    &.is-left::before {
      @include pointer-placement($content-border-width $content-border-width 0 0, auto, auto, -$content-pointer-size, $content-pointer-distance-in);
    }
  }
}
